// chat
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const REFRESH_MESSAGE_TRANSLATIONS = 'REFRESH_MESSAGE_TRANSLATIONS';
export const CLEAR_MESSAGE_TRANSLATIONS = 'CLEAR_MESSAGE_TRANSLATIONS';

// room
export const SET_ROOM_AUDIO_MUTED_STATE = 'SET_ROOM_AUDIO_MUTED_STATE';
export const SET_ROOM_VIDEO_MUTED_STATE = 'SET_ROOM_VIDEO_MUTED_STATE';
export const SET_ROOM_CHAT_MUTED_STATE = 'SET_ROOM_CHAT_MUTED_STATE';
export const SET_ROOM_VOICE_POSITIONAL_MODE_STATE =
  'SET_ROOM_VOICE_POSITIONAL_MODE_STATE';
export const SET_ROOM_VIDEO_POSITIONAL_MODE_STATE =
  'SET_ROOM_VIDEO_POSITIONAL_MODE_STATE';

// consumers
export const ADD_CONSUMER = 'ADD_CONSUMER';
export const REMOVE_CONSUMER = 'REMOVE_CONSUMER';
export const CLEAR_CONSUMERS = 'CLEAR_CONSUMERS';

// peer
export const ADD_PEER = 'ADD_PEER';
export const SET_PEER_AUDIO_MUTED = 'SET_PEER_AUDIO_MUTED';
export const SET_PEER_VIDEO_MUTED = 'SET_PEER_VIDEO_MUTED';
export const SET_PEER_CHAT_MUTED = 'SET_PEER_CHAT_MUTED';
export const SET_PEER_TRANSFORM = 'SET_PEER_TRANSFORM';
export const SET_PEER_PHOTO_URL = 'SET_PEER_PHOTO_URL';
export const SET_PEER_EMOTES = 'SET_PEER_EMOTES';

// me
export const SET_ME_CHAT_MUTED = 'SET_ME_CHAT_MUTED';
export const SET_ME_AUDIO_MUTED = 'SET_ME_AUDIO_MUTED';
export const SET_ME_VIDEO_MUTED = 'SET_ME_VIDEO_MUTED';
export const SET_ME_TRANSFORM = 'SET_ME_TRANSFORM';
export const SET_ME_INFO = 'SET_ME_INFO';
export const SET_ME = 'SET_ME';
